module.exports = __webpack_public_path__ + "static/kthLogo-d2ebd7e778bb3b468868defc14cfd86e.png";